module.exports = __webpack_public_path__ + "assets/img/audio_background.90520e2a.png";